import { useQuery } from '@tanstack/react-query';

import type { DevPushStateData } from '@sb/feathers-types';
import { getDevPushState } from '@sbrc/services';

const POLL_INTERVAL_MS = 10_000;

/**
 * React hook that polls the dev-push state from feathers-bot every 10s.
 *
 * Returns `{ source: null }` until the first fetch resolves, then the latest
 * known state. The banner renders only when `source !== null`.
 */
export function useDevPushState(): DevPushStateData {
  const { data } = useQuery({
    queryKey: ['devPushState'],
    queryFn: getDevPushState,
    refetchInterval: POLL_INTERVAL_MS,
    refetchIntervalInBackground: true,
  });

  return data ?? { source: null };
}
